module.exports = __webpack_public_path__ + "static/media/balletdancer.9b89714f.jpg";